export default "images/missing-item-2.jpg";